//import useState hook to create menu collapse state
import React, { useState } from "react";
import { Link as RouteLink } from "react-router-dom"
import { useLocation } from "react-router-dom";
//import react pro sidebar components
import {
  ProSidebar,
  Menu,
  MenuItem,
  SidebarHeader,
  SidebarFooter,
  SidebarContent,
} from "react-pro-sidebar";
import {Image , Link} from '@chakra-ui/react';
//import icons from react icons
import { FaList } from "react-icons/fa";
import { FiHome, FiLogOut, FiArrowLeftCircle, FiArrowRightCircle } from "react-icons/fi";
import { RiExchangeDollarLine } from "react-icons/ri";
// import { AiOutlineUngroup } from 'react-icons/ai'
//import { BsFiles } from "react-icons/bs";
// import { RiPencilLine } from "react-icons/ri";
import { BiCog } from "react-icons/bi";
// import * as GoIcon from "react-icons/go";
import logo from './logo.png'

////import sidebar css from react-pro-sidebar module and our custom css 
//import "react-pro-sidebar/dist/css/styles.css";
import "./Sidebar.css";

import AuthService from '../../../services/auth.service'

const Sidebar = () => {
  
      const logOut=() =>{
        AuthService.logout();
      }

    const location = useLocation();
    const { pathname } = location;
    const splitLocation = pathname.split("/");
    //create initial menuCollapse state using useState hook
    const [menuCollapse, setMenuCollapse] = useState(JSON.parse(localStorage.getItem("sidebar")));

    //create a custom function that will change menucollapse state from false to true and true to false
  const menuIconClick = () => {
    //condition checking to change state from true to false and vice versa
    if(menuCollapse){ 
      setMenuCollapse(false)
      localStorage.setItem("sidebar", false); 
     }else{
      setMenuCollapse(true);
      localStorage.setItem("sidebar", true); 
     } 
  };

  return (
    <>
      <div id="header" className="open">
          {/* collapsed props to change menu size using menucollapse state */}
        <ProSidebar collapsed={menuCollapse}>
          <SidebarHeader>
          <div className="logotext">
              {/* small and big change using menucollapse state */}
              {!menuCollapse && 
                    <Image
                    p={4}
                    borderRadius="lg"
                    width={{ md: 40 }}
                    src={logo}
                    alt="logo-PaymentOptions"
                  />
              }
            </div>
             {/* changing menu collapse icon on click */}
            <div className={menuCollapse ? "openmenu" : "closemenu"} onClick={menuIconClick}>
               
              {menuCollapse ? (
                <FiArrowRightCircle/>
              ) : (
                <FiArrowLeftCircle/>
              )}
            </div>
            
          </SidebarHeader>
          <SidebarContent>
            <Menu iconShape="square">
              <MenuItem icon={<FiHome />} active={splitLocation[1] === "statistics" ? "active" : ""}><Link as={RouteLink} to="/statistics">Statistics</Link></MenuItem>
              <MenuItem icon={<RiExchangeDollarLine />} active={splitLocation[1] === "transaction" ? "active" : ""}><Link as={RouteLink} to="/transaction">Transaction</Link></MenuItem>
              {/* <MenuItem active={splitLocation[1] === "transaction" ? "active" : ""}  icon={<RiExchangeDollarLine />}>
                  <Link as={RouteLink} to="/transaction" >Transaction</Link>
              </MenuItem> */}
              <MenuItem icon={<FaList />} active={splitLocation[1] === "cases" || splitLocation[1] === "cases-group-by-week"  ? "active" : ""}><Link as={RouteLink} to="/cases">Cases</Link></MenuItem>
              {/* <MenuItem icon={<FaLayerGroup />} active={splitLocation[1] === "cases-group-by-week" ? "active" : ""}><Link as={RouteLink} to="/cases-group-by-week">Cases weekly</Link></MenuItem> */}
              <MenuItem icon={<BiCog />} active={splitLocation[1] === "preference" ? "active" : ""}><Link as={RouteLink} to="/preference">Preference</Link></MenuItem>
              {/* <MenuItem icon={<BsFiles />} active={splitLocation[1] === "files" ? "active" : ""}><Link as={RouteLink} to="/files">Files</Link></MenuItem> */}
            </Menu>
          </SidebarContent>
          <SidebarFooter>
            <Menu iconShape="square">
              <MenuItem icon={<FiLogOut />}>
                <Link as={RouteLink} to="/login" onClick={(i) => logOut(i)} >Logout</Link>
              </MenuItem>
            </Menu>
          </SidebarFooter>
        </ProSidebar>
      </div>
    </>
  );
};

export default Sidebar;